// BARCHALO PROPERTIES (PTY) LTD - Company Data

export const companyInfo = {
  name: "BARCHALO",
  fullName: "BARCHALO PROPERTIES (PTY) LTD",
  tagline: "Construction & Formwork",
  heroHeadline: "Building Excellence, One Project at a Time",
  heroSubtext: "With over 40 years of industry experience, we are a leading specialist formwork company based in the Western Cape, delivering formwork, reinforcement, and concrete services of the highest standard.",
  phone: "(021) 820 3320",
  email: "violet@barchalo.co.za",
  address: "8 Matthee Street, Parow East, Western Cape, 7500",
  logo: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/qkg5geoy_FINAL-BAR-LOGO.png",
  registrationNumber: "2013/047610/07",
  vatNumber: "VAT Compliant",
  bibcNumber: "94342",
  bibcRegistrationDate: "11 JUNE 2013",
  socials: {
    facebook: "https://facebook.com/barchalo",
    instagram: "https://instagram.com/barchalo",
    linkedin: "https://linkedin.com/company/barchalo"
  }
};

export const services = [
  {
    id: 1,
    title: "Formwork & Falsework",
    description: "Expert formwork systems for concrete structures of any scale, using modern systems and tailored engineering solutions.",
    icon: "Layers"
  },
  {
    id: 2,
    title: "Reinforcement Placement",
    description: "Precision reinforcement placement ensuring structural integrity and compliance with engineering specifications.",
    icon: "Grid3X3"
  },
  {
    id: 3,
    title: "Concrete Works",
    description: "Complete concrete services from preparation to finishing, delivered with expertise and attention to detail.",
    icon: "Building2"
  },
  {
    id: 4,
    title: "Project-Specific Solutions",
    description: "Custom engineering solutions using modern systems tailored to your project's unique requirements.",
    icon: "Settings"
  }
];

export const serviceDetails = {
  technicalExpertise: "Technical Expertise",
  preConstruction: "Pre-construction Planning",
  selfPerformance: "Self-Performance Capabilities",
  problemSolving: "Proactive Problem Solving"
};

export const whyChooseUs = [
  {
    id: 1,
    title: "40+ Years Experience",
    description: "Decades of expertise in the South African construction industry."
  },
  {
    id: 2,
    title: "BIBC Registered",
    description: "Fully registered with The Building Industry Bargaining Council (Cape of Good Hope)."
  },
  {
    id: 3,
    title: "Quality Guaranteed",
    description: "Premium materials and workmanship on every project."
  },
  {
    id: 4,
    title: "Safety First",
    description: "Safety is a core value with continuous training, monitoring, and accountability."
  }
];

export const companyValues = [
  {
    id: 1,
    title: "Commitment",
    description: "We are dedicated to delivering excellence in every project we undertake."
  },
  {
    id: 2,
    title: "Honesty & Integrity",
    description: "Transparent communication and ethical business practices in all dealings."
  },
  {
    id: 3,
    title: "Customer Focus",
    description: "Your vision is our priority. We listen, advise, and deliver exactly what you need."
  },
  {
    id: 4,
    title: "Innovation & Openness",
    description: "Embracing new technologies and methods to deliver better results."
  },
  {
    id: 5,
    title: "Safety",
    description: "Safety is a core value, not just a policy. Creating safe working environments is paramount."
  },
  {
    id: 6,
    title: "Teamwork & Leadership",
    description: "Working collaboratively with clients, architects, engineers, and subcontractors."
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Barret Fortuin",
    role: "Managing Director",
    phone: "071 422 6604",
    bio: "Founder of Barchalo Properties with over 40 years of industry experience, leading the company with expertise and vision.",
    image: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/a4efkv7c_Professional_Studio_Photoshoot_A_man_with_dark_hair_and_brown_eyes_is_formally_uTAmcdo6.png"
  },
  {
    id: 4,
    name: "Chad Fortuin",
    role: "Director",
    phone: "078 493 8635",
    bio: "Project Manager, Operations Management and coordinator between clients and sites.",
    image: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/qhhf9z7e_Logo_test_designs_A_man_with_dark_hair_and_brown_eyes_wears_a_dark_YIiR5qwe.jpg"
  },
  {
    id: 5,
    name: "Logan Fortuin",
    role: "Director",
    phone: "066 307 0623",
    bio: "Office administrative duties.",
    image: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/o5cu05k1_WhatsApp%20Image%202026-04-24%20at%2010.16.36.jpeg"
  },
  {
    id: 2,
    name: "Violet Janson",
    role: "Financial Director",
    phone: "021 820 3320",
    bio: "Ensuring smooth operations and efficient communication across all company activities. Oversees the company's financial operations, including budgeting, payroll, and financial reporting.",
    image: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/ydpcz8h0_WhatsApp%20Image%202026-04-23%20at%2011.37.12.jpeg"
  },
  {
    id: 3,
    name: "Garth Stalmeester",
    role: "Procurement Director",
    phone: "078 395 7018",
    bio: "Expert in cost management and ensuring projects are delivered within budget.",
    image: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/8vqi7caj_WhatsApp%20Image%202026-04-23%20at%2017.39.16%20%281%29.jpeg"
  },
  {
    id: 6,
    name: "Le-Colen Marthinus",
    role: "Project Manager",
    phone: "061 452 8063",
    bio: "Ensuring all projects run smoothly liaising with foreman and client supervisors. Planning and allocating labor resources according to project requirements.",
    image: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/v76kylew_WhatsApp%20Image%202026-04-24%20at%2009.27.47.jpeg"
  }
];

export const stats = [
  { id: 1, value: "40+", label: "Years Experience" },
  { id: 2, value: "100+", label: "Projects Completed" },
  { id: 3, value: "R90M+", label: "Project Value" },
  { id: 4, value: "2013", label: "Established" }
];

export const vision = "To lead the construction industry through innovation, integrity, and excellence, while fostering strong relationships and delivering value to all stakeholders.";

export const foundingVision = [
  "To achieve steady growth through annual revenue increases.",
  "To maintain consistent profitability in every financial year."
];

export const aboutCompany = {
  intro: "Founded by Barret Fortuin, Barchalo Properties (formerly Quincy Construction) is a leading specialist formwork company based in the Western Cape.",
  history: "With over 40 years of industry experience, we have built a solid reputation for delivering formwork, reinforcement, and concrete services of the highest standard. Starting from humble beginnings in the residential sector, Barchalo has grown to become a trusted partner in commercial, industrial, and public infrastructure projects.",
  approach: "We are known for our modern formwork systems, experienced teams, and commitment to excellence. Our collaborative, solutions-oriented mindset focuses on successful, timely, and quality-driven project delivery, working in partnership with clients, architects, engineers, and subcontractors.",
  safety: "Safety is a core value, not just a policy. We are committed to creating and maintaining safe working environments. Our proactive safety culture ensures every team member understands their role. Continuous training, monitoring, and accountability are key to our operations."
};

// Major/Featured Projects
export const portfolioItems = [
  {
    id: 1,
    title: "House Erasmus - Langebaan",
    category: "Residential",
    client: "Private Client",
    duration: "8 months",
    value: "R2,500,000.00",
    completionDate: "2024",
    image: "/projects/house_erasmus_1.jpeg",
    description: "Luxury coastal residence in Langebaan with complex concrete structures."
  },
  {
    id: 2,
    title: "Eversdal Primary School",
    category: "Commercial",
    client: "Education Department",
    duration: "10 months",
    value: "R3,200,000.00",
    completionDate: "2024",
    image: "/projects/eversdal_school_1.jpeg",
    description: "School building construction with comprehensive formwork and concrete works."
  },
  {
    id: 3,
    title: "Lourensford Motor Display",
    category: "Commercial",
    client: "Private Client",
    duration: "6 months",
    value: "R1,800,000.00",
    completionDate: "2024",
    image: "/projects/lourensford_motor_3.jpeg",
    description: "Modern motor display facility with architectural concrete features."
  },
  {
    id: 4,
    title: "Prince Georges Drive School Hall",
    category: "Commercial",
    client: "Education Department",
    duration: "8 months",
    value: "R2,100,000.00",
    completionDate: "2024",
    image: "/projects/prince_georges_2.jpeg",
    description: "Large school hall construction with extensive formwork requirements."
  },
  {
    id: 5,
    title: "House Adendorff - Langebaan",
    category: "Residential",
    client: "JNA Projects",
    duration: "8 months",
    value: "R941,742.50",
    completionDate: "February 2025",
    image: "/projects/house_adendorff.jpeg",
    description: "Luxury residential project in Langebaan with stunning views."
  },
  {
    id: 6,
    title: "Luxury Homes - Sitari Estate",
    category: "Residential",
    client: "VPM Building",
    duration: "10 months",
    value: "R2,000,000.00",
    completionDate: "2024",
    image: "/projects/sitari_estate.jpeg",
    description: "Premium residential development at Sitari Estate."
  },
  {
    id: 7,
    title: "Anura Wine Estate",
    category: "Residential",
    client: "Forz Construction",
    duration: "4 months",
    value: "R2,527,153.96",
    completionDate: "December 2024",
    image: "https://images.unsplash.com/photo-1635682738019-e529062c508a?w=800&q=80",
    description: "Multiple luxury stands at the prestigious Anura Wine Estate."
  },
  {
    id: 8,
    title: "Greenpoint Soccer Stadium",
    category: "Commercial",
    client: "Murray and Roberts",
    duration: "24 months",
    value: "R19,101,500.00",
    completionDate: "30 October 2009",
    image: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/4q0h5loo_WhatsApp%20Image%202026-02-11%20at%205.56.11%20AM.jpeg",
    description: "Major formwork contract for the iconic Cape Town Stadium built for the 2010 FIFA World Cup."
  },
  {
    id: 9,
    title: "Century City - Canal Walk",
    category: "Commercial",
    client: "Murray and Roberts",
    duration: "24 months",
    value: "R23,650,000.00",
    completionDate: "13 December 2000",
    image: "https://images.unsplash.com/photo-1609183883148-8bc5cb6fccbb?w=800&q=80",
    description: "Large-scale formwork project for one of South Africa's premier shopping destinations."
  },
  {
    id: 10,
    title: "V&A Breakwater Parkade",
    category: "Commercial",
    client: "Murray and Roberts",
    duration: "11 months",
    value: "R6,575,000.00",
    completionDate: "25 November 2006",
    image: "https://images.unsplash.com/photo-1646558582818-17d85b393c4a?w=800&q=80",
    description: "Multi-story parkade at the V&A Waterfront precinct."
  },
  {
    id: 11,
    title: "Cape Town International Parkade",
    category: "Commercial",
    client: "WHBO",
    duration: "14 months",
    value: "R4,989,500.00",
    completionDate: "12 December 2005",
    image: "https://images.unsplash.com/photo-1658899818108-64b723a317b4?w=800&q=80",
    description: "Parkade construction at Cape Town International Airport."
  },
  {
    id: 12,
    title: "Promenade Mall",
    category: "Commercial",
    client: "Murray and Roberts",
    duration: "12 months",
    value: "R8,785,000.00",
    completionDate: "10 December 2010",
    image: "https://images.unsplash.com/photo-1721155810182-e92747822c54?w=800&q=80",
    description: "Complete formwork services for this popular shopping centre."
  }
];

// Recent/Current Project References
export const projectReferences = [
  {
    id: 1,
    title: "Luxury Homes",
    location: "Yzerfontein",
    client: "McNeil Construction",
    contact: "Douglas Wheatley",
    phone: "082 041 5383",
    website: "www.mcneil.co.za"
  },
  {
    id: 2,
    title: "Upmarket Homes",
    location: "Anura Wine Estate",
    client: "Forz Construction",
    contact: "Mark Forsman",
    phone: "083 600 0721"
  },
  {
    id: 3,
    title: "Luxury Homes",
    location: "Sitari Estate",
    client: "VPM Building",
    contact: "Abel Vicente",
    phone: "084 352 5585"
  },
  {
    id: 4,
    title: "Bakoven Alterations",
    location: "Bakoven",
    client: "4D Construction",
    contact: "Sharief Amien",
    phone: "082 456 4212"
  },
  {
    id: 5,
    title: "Luxury Homes & Apartments",
    location: "Various",
    client: "OHB Construction",
    contact: "Benno Albertyn",
    phone: "082 807 2047"
  }
];

// Full project list from 2024
export const completedProjects2024 = [
  { name: "Anura Wine Estate - Stand 15 & 13", client: "Forz Construction", value: "R941,243.71", date: "30 September 2024" },
  { name: "Anura Wine Estate - Stand 3", client: "Forz Construction", value: "R277,000.35", date: "31 October 2024" },
  { name: "Anura Wine Estate - Stand 39 & 28", client: "Forz Construction", value: "R771,865.63", date: "06 December 2024" },
  { name: "Anura Wine Estate - Stand 23", client: "Forz Construction", value: "R148,332.95", date: "25 November 2024" },
  { name: "Anura Wine Estate - Restaurant & Farm House", client: "Forz Construction", value: "R388,711.32", date: "12 December 2024" },
  { name: "Apex School - Stellenbosch", client: "Harold Turner Construction", value: "R599,983.75", date: "31 January 2025" },
  { name: "Erf 1582 House Herholdt - Val de Vie", client: "JJ Dempers", value: "R810,010.55", date: "31 January 2025" },
  { name: "House Adendorff - Yzerfontein", client: "JNA Group", value: "R941,742.50", date: "28 February 2025" },
  { name: "Erf 705 House Tseng - Val de Vie", client: "Lewis Manhattan", value: "R302,633.64", date: "28 February 2025" },
  { name: "Erf 770 House Duckitt - Val de Vie", client: "Lewis Manhattan", value: "R324,935.97", date: "31 March 2025" },
  { name: "House Reade - Franschhoek", client: "OHB Construction", value: "R403,300.84", date: "15 November 2024" },
  { name: "House Slabbert - Franschhoek", client: "OHB Construction", value: "R403,300.84", date: "15 November 2024" },
  { name: "Kanonkop Warehouse", client: "OHB Construction", value: "R168,252.42", date: "06 December 2024" },
  { name: "Erf 1590 House Du Plooy - Val de Vie", client: "Rendev Property Group", value: "R2,372,798.05", date: "30 October 2025" },
  { name: "Angala Boutique Farm - Franschhoek", client: "Mimosa Projects", value: "R714,549.93", date: "30 March 2025" },
  { name: "Hillview Academy", client: "WM Construction", value: "R773,402.06", date: "31 March 2025" },
  { name: "House Le Roux - Paarl", client: "McNeil Construction", value: "R1,319,055.36", date: "15 November 2024" }
];


// Gallery Images - Add more images here
// Each image should have: { src: "/path/to/image.jpg", caption: "Optional caption" }
export const galleryImages = [
  { src: "/projects/house_erasmus_1.jpeg", caption: "House Erasmus - Langebaan" },
  { src: "/projects/house_erasmus_2.jpeg", caption: "House Erasmus - Construction Progress" },
  { src: "/projects/house_erasmus_3.jpeg", caption: "House Erasmus - Formwork" },
  { src: "/projects/house_erasmus_4.jpeg", caption: "House Erasmus - Concrete Work" },
  { src: "/projects/eversdal_school_1.jpeg", caption: "Eversdal Primary School" },
  { src: "/projects/eversdal_school_2.jpeg", caption: "Eversdal School - Construction" },
  { src: "/projects/eversdal_school_3.jpeg", caption: "Eversdal School - Progress" },
  { src: "/projects/eversdal_school_4.jpeg", caption: "Eversdal School - Formwork" },
  { src: "/projects/lourensford_motor_1.jpeg", caption: "Lourensford Motor Display" },
  { src: "/projects/lourensford_motor_2.jpeg", caption: "Lourensford - Construction" },
  { src: "/projects/lourensford_motor_3.jpeg", caption: "Lourensford - Progress" },
  { src: "/projects/prince_georges_1.jpeg", caption: "Prince Georges Drive School Hall" },
  { src: "/projects/prince_georges_2.jpeg", caption: "Prince Georges - Construction" },
  { src: "/projects/prince_georges_3.jpeg", caption: "Prince Georges - Formwork" },
  { src: "/projects/house_adendorff.jpeg", caption: "House Adendorff - Langebaan" },
  { src: "/projects/sitari_estate.jpeg", caption: "Sitari Estate - Luxury Homes" },
  { src: "/projects/construction_interior.jpeg", caption: "Interior Construction Work" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/n30gcft6_WhatsApp%20Image%202026-02-11%20at%205.56.11%20AM%20%2810%29.jpeg", caption: "Reinforcement & Formwork Installation" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/7ucz1zuv_WhatsApp%20Image%202026-02-11%20at%205.56.11%20AM%20%2811%29.jpeg", caption: "Column Construction - On Site" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/twzosm72_WhatsApp%20Image%202026-02-11%20at%205.56.11%20AM%20%2812%29.jpeg", caption: "Concrete Walls & Columns" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/gzc0bm1j_WhatsApp%20Image%202026-02-11%20at%205.56.11%20AM%20%2813%29.jpeg", caption: "Wall Construction Progress" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/vbxov5ug_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%281%29.jpeg", caption: "Column Formwork Installation" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/544gzwhr_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%282%29.jpeg", caption: "Foundation Column Work" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/vlnumqie_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%283%29.jpeg", caption: "Site Team - Column Construction" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/fvdxxz6m_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%284%29.jpeg", caption: "Staircase Formwork Construction" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/64yx8zhx_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%285%29.jpeg", caption: "Staircase Formwork Detail" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/lpbuikwy_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%286%29.jpeg", caption: "Interior Staircase Installation" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/6msqpn4b_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%287%29.jpeg", caption: "Construction Site Progress" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/s3iimvkz_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%288%29.jpeg", caption: "Formwork Structure" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/ui61jlv1_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%289%29.jpeg", caption: "Concrete Framework" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/454qfhb8_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%2810%29.jpeg", caption: "Site Development" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/ac23p7ye_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%2811%29.jpeg", caption: "Building Construction" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/o1dcuvra_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%2812%29.jpeg", caption: "Construction Progress" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/5ya592rm_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%2813%29.jpeg", caption: "Site Framework" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/1anlgdgm_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%2814%29.jpeg", caption: "Structural Work" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/cjy29ybr_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%2815%29.jpeg", caption: "Formwork Installation" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/ihserzdl_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%2816%29.jpeg", caption: "Concrete Structure" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/5fusrkk2_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%2817%29.jpeg", caption: "Site Construction Work" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/0l1gpivg_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%2818%29.jpeg", caption: "Building Framework" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/1snhamsz_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%2819%29.jpeg", caption: "Structural Development" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/jdygx7m4_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%2820%29.jpeg", caption: "Construction Progress" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/v07o0nam_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%2821%29.jpeg", caption: "Site Development" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/dlk21bzv_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%2822%29.jpeg", caption: "Foundation Work" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/jgwmjjnb_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%2823%29.jpeg", caption: "Reinforcement Installation" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/hqgg8kdo_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%2824%29.jpeg", caption: "Concrete Pouring" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/t500tbt1_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%2825%29.jpeg", caption: "Structural Framework" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/sbaflmxl_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%2826%29.jpeg", caption: "Building Progress" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/43h9qxqv_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%2831%29.jpeg", caption: "Column Formwork Scaffolding" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/eejc1loo_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%2832%29.jpeg", caption: "Multiple Column Construction" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/ftkpfk81_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%2833%29.jpeg", caption: "Scaffolding Structure" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/j0a2vekb_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%2834%29.jpeg", caption: "Large Scale Construction" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/on28lkim_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%2835%29.jpeg", caption: "Commercial Building Progress" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/mmklryf8_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%2837%29.jpeg", caption: "Multi-Storey Tower Construction" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/47sajgy2_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%2838%29.jpeg", caption: "Upper Level Slab Formwork" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/n4syhe0k_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%2839%29.jpeg", caption: "Completed Concrete Wall Finish" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/37zqxnjg_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%2840%29.jpeg", caption: "Precast Wall Installation" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/5s1vlf0j_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%2841%29.jpeg", caption: "Reinforced Foundation Pour" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/iea5dz9y_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%2842%29.jpeg", caption: "Rebar Cage Reinforcement Setup" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/olc89276_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM%20%2843%29.jpeg", caption: "PERI Wall Formwork System" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/gy1aypdi_WhatsApp%20Image%202026-02-11%20at%205.56.12%20AM.jpeg", caption: "Column Erection - New Build Site" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/adiabf1n_WhatsApp%20Image%202026-02-11%20at%205.59.56%20AM%20%281%29.jpeg", caption: "Aerial View - Multi-Unit Residential" },
  { src: "https://customer-assets.emergentagent.com/job_87a42c2d-b3ff-4965-9d7d-e392365dc691/artifacts/1hjq710c_WhatsApp%20Image%202026-02-11%20at%205.59.56%20AM%20%282%29.jpeg", caption: "Aerial View - Townhouse Development" }
];
